import { render, staticRenderFns } from "./EditarComarca.vue?vue&type=template&id=2ea57a95&scoped=true"
import script from "./EditarComarca.vue?vue&type=script&lang=js"
export * from "./EditarComarca.vue?vue&type=script&lang=js"
import style0 from "./EditarComarca.vue?vue&type=style&index=0&id=2ea57a95&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea57a95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ea57a95')) {
      api.createRecord('2ea57a95', component.options)
    } else {
      api.reload('2ea57a95', component.options)
    }
    module.hot.accept("./EditarComarca.vue?vue&type=template&id=2ea57a95&scoped=true", function () {
      api.rerender('2ea57a95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EditarComarca.vue"
export default component.exports